document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".video-grid__card");
  let currentVideo = null;
  cards.forEach((card) => {
    const video = card.querySelector("video");
    const overlay = card.querySelector(".video-grid__overlay");
    if (!video) return;
    card.addEventListener("click", () => {
      if (currentVideo && currentVideo !== video) {
        currentVideo.pause();
        currentVideo.currentTime = 0;
        const prevCard = currentVideo.closest(".video-grid__card");
        const prevOverlay = prevCard.querySelector(".video-grid__overlay");
        if (prevOverlay) prevOverlay.style.display = "flex";
      }
      if (video.paused) {
        video.play();
        overlay.style.display = "none";
        currentVideo = video;
      } else {
        video.pause();
        video.currentTime = 0;
        overlay.style.display = "flex";
        currentVideo = null;
      }
    });
  });
});